import { Endpoint } from '../endpoint';
import { ProgramId, ProgramTargetResponse, TargetId, ProgramStepCompletedResponse, StepCompletedId } from '@business/entities/programs';
import { UserId } from '@business/entities/account';
import { defer, of } from 'rxjs';
import axios from 'axios';
import { CommonService } from '@business/services';

export function fetchProgramTargets(id: ProgramId) {
  return Endpoint.get<ProgramTargetResponse[]>(`@makh/program-section-steps/program-section-steps/${id}`);
}

export function fetchProgramTarget(id: TargetId) {
  return Endpoint.get<ProgramTargetResponse>(`@makh/program-section-steps/program-section-step/${id}`);
}

export function deleteProgramTarget(id: TargetId) {
  return Endpoint.delete<void>(`@makh/program-section-steps/${id}`);
}

export function createProgramTarget(data: Partial<ProgramTargetResponse>) {
  return Endpoint.post<ProgramTargetResponse>(`@makh/program-section-steps`, { data });
}

export function updateProgramTarget(targetId: TargetId, data: Partial<ProgramTargetResponse>) {
  return Endpoint.patch<ProgramTargetResponse>(`@makh/program-section-steps/${targetId}`, { data });
}

export function sortProgramTarget(target: ProgramTargetResponse, toColumn: any, toPosition: number) {
  return Endpoint.post<ProgramTargetResponse[]>(`@makh/program-section-steps/sort-program-section-steps`, { data: { target, toColumn, toPosition } });
}

export function markProgramTargetCompleted(val: boolean, targetId: TargetId, userId: UserId) {
  return Endpoint.post<ProgramTargetResponse>(`@makh/program-section-steps/mark-program-section-step-completed`, { data: { val, targetId, userId } });
}

export function sendProgramNudge(stepId: TargetId) {
  return Endpoint.post<ProgramTargetResponse>(`@makh/program-section-steps/send-nudge/${stepId}`);
}

export function submitComplianceReport(data: Partial<ProgramStepCompletedResponse>) {
  const formData = CommonService.toFormData(data);
  return Endpoint.post<ProgramTargetResponse>(`@makh/program-section-steps/create-compliance-report/${data.stepId}`, { formData, hasFiles: true });
}

export function approveTargetReport(stepCompletedId: StepCompletedId, userId: UserId) {
  return Endpoint.post<ProgramTargetResponse>(`@makh/program-section-steps/approve-program-section-step-report`, {
    data: { stepCompletedId, userId },
  });
}

export function rejectTargetReport(stepCompletedId: StepCompletedId, userId: UserId) {
  return Endpoint.post<ProgramTargetResponse>(`@makh/program-section-steps/reject-program-section-step-report`, {
    data: { stepCompletedId, userId },
  });
}

export function fetchProgramUserTargets(id: UserId) {
  return Endpoint.get<ProgramTargetResponse[]>(`@makh/program-section-steps/program-user-section-steps/${id}`);
}

export function updateAssignedusers(targetId: TargetId, userId: UserId[]) {
  return Endpoint.patch<ProgramTargetResponse>(`@makh/program-section-steps/update-assignee/${targetId}`, { data: { userId } });
}
